.ColumnControllerControl578115195__root {
  gap: 3px;
  background-color: #fff;
}


/* st-namespace-reference="../../../../src/controls/ColumnController/ColumnControllerControl.st.css" */